import React from 'react';
import PropTypes from 'prop-types';
import { Redirect, Route } from 'react-router-dom';

export const PrivateRoute = ({ exact, render: Component, hasAccess, redirectTo, redirectToState = {}, ...rest }) => (
  <Route
    {...rest}
    exact={exact}
    render={(props) =>
      hasAccess ? <Component {...props} /> : <Redirect to={{ ...redirectTo, state: redirectToState }} />
    }
  />
);

PrivateRoute.propTypes = {
  exact: PropTypes.bool,
  path: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]).isRequired,
  hasAccess: PropTypes.bool,
  redirectTo: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.shape({
      pathname: PropTypes.string,
      search: PropTypes.string,
      hash: PropTypes.string,
      state: PropTypes.any,
    }),
  ]),
  render: PropTypes.func.isRequired,
};

PrivateRoute.defaultProps = {
  exact: false,
  hasAccess: false,
  redirectTo: '/',
};
